<template>
    <vue-final-modal name="subscript-modal" class="modal-common member-ship"
                     v-model="showModal"
                     :transition="`modal-bottom`"
                     @before-open="handlerBeforeOpen"
                     @before-close="handlerBeforeClose"
                     @closed="handlerClosed"
                     :click-to-close="false"
                     :esc-to-close="false"
    >
        <div class="container-member">
            <div class="title">{{ returnTitle() }}</div>
            <div class="w100p">
                <div class="info-grid">
                    <div class="info-title">상품명</div>
                    <div class="data">{{ subscriptData.itName }}</div>
                    <div class="info-title">변경예정일</div>
                    <div class="data">{{ subscriptData.snChangeDate }}</div>
                    <template v-if="subscriptData.sncType !=='CHANGE_PRODUCT'">
                        <div class="info-title">{{ returnPriceTitle() }}</div>
                        <div class="data">{{ returnCommas(subscriptData.snPrice) }}원</div>
                    </template>
                </div>
            </div>
            <div class="container-content" v-html="returnContent()">
            </div>
            <div class="term  mt20">
                ※ 동의 시 상품 구독이 계속 유지되며, 이용요금 변경 적용일 이후 첫 결제부터 인상된 금
                액으로 적용됩니다.
            </div>
            <div class="term mt4">
                ※ 거절 시 해당 상품의 구독이 취소되며, 다음 회차부터 이용이 불가합니다.
            </div>
            <button class="confirm-btn" @click="confirmNotice()">모든 내용을 확인했습니다</button>
        </div>
    </vue-final-modal>
</template>

<script>
import {mapState} from "vuex";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import NumberMixins from "@/mixins/NumberMixins.js";

export default {
    name: "SubscriptModal",
    mixins: [alertMixins, NumberMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            showModal: false,

            subscriptData: {},
            index: -1,
        }
    },
    beforeRouterEnter() {
    },
    created() {

    },
    mounted() {

    },
    beforeUnmount() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        handlerBeforeOpen(event) {
            this.index = -1;

            if (!util.isEmpty(event.ref.params.value.subscriptData)) {
                this.subscriptData = event.ref.params.value.subscriptData;
            }
            if (!util.isEmpty(event.ref.params.value.index)) {
                this.index = event.ref.params.value.index;
            }
        },
        handlerBeforeClose() {
            this.subscriptData = {};
        },
        handlerClosed() {
            EventBus.$emit('checkNextSubscript', this.index + 1);
        },

        modalClose() {
            this.$vfm.hide('subscript-modal');
        },


        returnTitle() {
            switch (this.subscriptData.sncType) {
                case 'PRICE_INCREASE':
                    return '구독서비스 요금 인상 안내';
                case 'PRICE_DECREASE':
                    return '구독서비스 요금 인하 안내';
                case 'CHANGE_PRODUCT':
                    return '구독서비스 구성 변경 안내';
                case 'PRICE_INCREASE&CHANGE_PRODUCT':
                    return '구독서비스 요금 인상 및 구성 변경 안내';
                case 'PRICE_DECREASE&CHANGE_PRODUCT':
                    return '구독서비스 요금 인하 및 구성 변경 안내';
                default :
                    return '구독서비스 변경 안내';
            }
        },

        returnPriceTitle() {
            switch (this.subscriptData.sncType) {
                case 'PRICE_INCREASE':
                    return '인상예정금액';
                case 'PRICE_DECREASE':
                    return '인하예정금액';
                case 'PRICE_INCREASE&CHANGE_PRODUCT':
                    return '인상예정금액';
                case 'PRICE_DECREASE&CHANGE_PRODUCT':
                    return '인하예정금액';
                default :
                    return '변경예정금액';
            }
        },

        confirmNotice() {
            this.createConfirm({
                title: '모든 내용 확인 안내',
                content: '안내된 금액 변경 또는 상품 구성 변경 내용, 변경 적용 시점, 구독 해지 방법에 대한 모든 내용을 충분히 확인하였습니다.<br>'
                    + '변경사항으로 인해 구독해지를 원하실 경우,<br>'
                    + '안내드린 내용에 따라 변경일 이전에 해지하실 수 있습니다.',
                confirm: () => {
                    this.createSubscript();
                },
            })
        },

        createSubscript() {

            EventBus.$emit('apiLoading', false);
            let params = {
                'snIdx': this.subscriptData.snIdx,
                'suIdx': this.subscriptData.suIdx,
            }
            try {
                this.$api.$subscript.confirmSubscript(params).then(res => {
                    EventBus.$emit('apiLoading', false);
                    if (res.code == 1) {

                        this.createAlert({
                            title: '모든 내용 확인 안내',
                            content: `${this.$date().format('YYYY년 MM월 DD일')}<br>`
                                + '안내된 금액 변경 또는 상품 구성 변경 내용<br>' +
                                '변경 적용 시점, 구독 해지 방법에 대한 모든 내용을 충분히 확인하였습니다',
                            hide: () => {
                                this.modalClose();
                            }
                        })
                    } else {
                        this.createAlert({
                            title: '데이터통신 실패',
                            content: `데이터 통신에 실패했습니다<br>잠시 후 다시 시도해주세요.`,
                        })
                    }
                })
            } catch (e) {
                EventBus.$emit.emit('apiLoading', false);
                console.log(e);
                this.createAlert({
                    title: '데이터통신 실패',
                    content: `데이터 통신에 실패했습니다<br>잠시 후 다시 시도해주세요.`,
                })
            }

        },


        returnContent() {

            switch (this.subscriptData.sncType) {
                case 'PRICE_INCREASE':
                    return '안녕하세요 레인보우TV입니다.<br><br>'
                        + `[${this.subscriptData.itName}] 구독 요금 인상 안내<br><br>`
                        + `[${this.subscriptData.itName}] 상품의 구독 금액이 ${this.subscriptData.snChangeDate} 부터 월 ${this.subscriptData.snPrice} 으로 인상됩니다.<br><br>`
                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 결제 수단별로 다음과 같이 인상 시점이 적용됩니다.<br>`
                        + `▶이니시스 / 카카오페이 / Npay : 인상일 이후 결제 회차부터 자동 적용<br>`
                        + '▶구글 / 애플 : 각 스토어 정책에 따라 인상 시점 자동 적용<br><br>'
                        + '구독 해지를 원하실 경우 아래 방법을 참고해주세요.<br>'
                        + '▶구글사용자<br>'
                        + '[ https://play.google.com/store/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[ 스마트폰 Google Play Store 앱 실행 → 프로필 → 지불 및 구독 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶애플사용자<br>'
                        + '[ https://apps.apple.com/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[스마트폰 ‘설정’ 앱 실행 → Apple ID 선택 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶이니시스 / 카카오페이 / Npay 사용자<br>'
                        + '[https://www.cmbrainbowtv.co.kr/ 접속 → 라이브 구독 → 상품 선택후 구독 취소]<br>'
                        + '더 나은 서비스를 위해 노력하겠습니다. 감사합니다.<br><br>'
                        + '※ 본 안내는 전자상거래법에 따른 가격 인상 사전 고지입니다.';
                case 'PRICE_DECREASE':
                    return '안녕하세요 레인보우TV입니다.<br><br>'
                        + `[${this.subscriptData.itName}] 구독 요금 인하 안내<br><br>`
                        + `[${this.subscriptData.itName}] 상품의 구독 금액이 ${this.subscriptData.snChangeDate} 부터 월 ${this.subscriptData.snPrice} 으로 인하됩니다.<br><br>`
                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 결제 수단별로 다음과 같이 인하 시점이 적용됩니다.<br>`
                        + '▶이니시스 / 카카오페이 / Npay : 인하일 이후 결제 회차부터 자동 적용<br>'
                        + '▶구글 / 애플 : 각 스토어 정책에 따라 인하 시점 자동 적용<br><br>'
                        + '더 나은 서비스를 위해 노력하겠습니다. 감사합니다.<br><br>'
                        + '※ 본 안내는 전자상거래법에 따른 가격 인하 사전 고지입니다.';
                case 'CHANGE_PRODUCT':
                    return '안녕하세요 레인보우TV입니다.<br><br>'
                        + `[${this.subscriptData.itName}] 상품 구성 변경 안내<br><br>`
                        + `[${this.subscriptData.itName}] 상품의 구성이 ${this.subscriptData.snChangeDate} 부터 변경됩니다<br><br>`
                        + `상품구성변경내용:<br>`
                        + `${this.subscriptData.snContext}<br><br>`

                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 변경일 이후 결제 회차부터 변경된 상품구성으로 이용 가능합니다.<br><br>`
                        + '구독 해지를 원하실 경우 아래 방법을 참고해주세요.<br>'
                        + '▶구글사용자<br>'
                        + '[ https://play.google.com/store/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[ 스마트폰 Google Play Store 앱 실행 → 프로필 → 지불 및 구독 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶애플사용자<br>'
                        + '[ https://apps.apple.com/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[스마트폰 ‘설정’ 앱 실행 → Apple ID 선택 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶이니시스 / 카카오페이 / Npay 사용자<br>'
                        + '[https://www.cmbrainbowtv.co.kr/ 접속 → 라이브 구독 → 상품 선택후 구독 취소]<br>'

                        + '더 나은 서비스를 위해 노력하겠습니다. 감사합니다.<br><br>'
                        + '※ 본 안내는 전자상거래법에 따른 상품구성 변경 사전 고지입니다.';
                case 'PRICE_INCREASE&CHANGE_PRODUCT':

                    return '안녕하세요 레인보우TV입니다.<br><br>'
                        + `[${this.subscriptData.itName}] 구독 요금 인상 및 상품 구성 변경 안내<br><br>`
                        + `[${this.subscriptData.itName}] 상품의 구독 금액이 ${this.subscriptData.snChangeDate} 부터 월 ${this.subscriptData.snPrice} 으로 인상 및 상품 구성이 변경됩니다<br><br>`

                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 결제 수단별로 다음과 같이 인상 시점이 적용됩니다.<br>`
                        + `▶이니시스 / 카카오페이 / Npay : 인상일 이후 결제 회차부터 자동 적용<br>`
                        + `▶구글 / 애플 : 각 스토어 정책에 따라 인상 시점 자동 적용<br><br>`

                        + `상품구성변경내용:<br>`
                        + `${this.subscriptData.snContext}<br><br>`

                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 변경일 이후 결제 회차부터 변경된 상품구성으로 이용 가능합니다.<br><br>`
                        + '구독 해지를 원하실 경우 아래 방법을 참고해주세요.<br>'
                        + '▶구글사용자<br>'
                        + '[ https://play.google.com/store/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[ 스마트폰 Google Play Store 앱 실행 → 프로필 → 지불 및 구독 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶애플사용자<br>'
                        + '[ https://apps.apple.com/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[스마트폰 ‘설정’ 앱 실행 → Apple ID 선택 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶이니시스 / 카카오페이 / Npay 사용자<br>'
                        + '[https://www.cmbrainbowtv.co.kr/ 접속 → 라이브 구독 → 상품 선택후 구독 취소]<br>'

                        + '더 나은 서비스를 위해 노력하겠습니다. 감사합니다.<br><br>'
                        + '※ 본 안내는 전자상거래법에 따른 상품구성 변경 및 가격 인상 사전 고지입니다.';

                case 'PRICE_DECREASE&CHANGE_PRODUCT':

                    return '안녕하세요 레인보우TV입니다.<br><br>'
                        + `[${this.subscriptData.itName}] 구독 요금 인하 및 상품 구성 변경 안내<br><br>`
                        + `[${this.subscriptData.itName}] 상품의 구독 금액이 ${this.subscriptData.snChangeDate} 부터 월 ${this.subscriptData.snPrice} 으로 인하 및 상품 구성이 변경됩니다<br><br>`

                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 결제 수단별로 다음과 같이 인하 시점이 적용됩니다.<br>`
                        + '▶이니시스 / 카카오페이 / Npay : 인하일 이후 결제 회차부터 자동 적용<br>'
                        + '▶구글 / 애플 : 각 스토어 정책에 따라 인하 시점 자동 적용<br><br>'

                        + '상품구성변경내용:<br>'
                        + `${this.subscriptData.snContext}<br><br>`

                        + `[${this.subscriptData.snChangeDate}] 이전에 구독을 시작하신 경우, 변경일 이후 결제 회차부터 변경된 상품구성으로 이용 가능합니다.<br><br>`
                        + '구독 해지를 원하실 경우 아래 방법을 참고해주세요.<br>'
                        + '▶구글사용자<br>'
                        + '[ https://play.google.com/store/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[ 스마트폰 Google Play Store 앱 실행 → 프로필 → 지불 및 구독 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶애플사용자<br>'
                        + '[ https://apps.apple.com/account/subscriptions 접속 → 상품 선택후 구독 취소 ]<br>'
                        + '[스마트폰 ‘설정’ 앱 실행 → Apple ID 선택 → 구독 → 상품 선택후 구독 취소]<br>'
                        + '▶이니시스 / 카카오페이 / Npay 사용자<br>'
                        + '[https://www.cmbrainbowtv.co.kr/ 접속 → 라이브 구독 → 상품 선택후 구독 취소]<br>'

                        + '더 나은 서비스를 위해 노력하겠습니다. 감사합니다.<br><br>'
                        + '※ 본 안내는 전자상거래법에 따른 상품구성 변경 및 가격 인하 사전 고지입니다.';


                default:
                    return '-';


            }
        },
    },
}
</script>

<style scoped>

</style>